// extracted by mini-css-extract-plugin
export default {"ProviderImg":"CoursePicture_ProviderImg__zHYWa","PictureWrapper":"CoursePicture_PictureWrapper__ic57-"};